import { OvertimeComponent } from "../../components";

export default function OvertimeRegistrationCreatePage() {
  return <OvertimeComponent.OvertimeRegistrationCreate />;
}
